export const enum EDragAndDropType {
  LOAD = 'LOAD',
  UNLINKED = 'UNLINKED',
  CANCELLED = 'CANCELLED'
}
